import { PANEL_OPTION_KEYS } from '@/utils/consts';

const { TABLE_METRIC, SINGULAR_METRIC, SORTING_METRIC_EXPOSURE, BREAKDOWN } =
    PANEL_OPTION_KEYS;

export const FIELD_PANEL_KEY = {
    [TABLE_METRIC]: () => 'MULTIPLE_METRIC',
    [SINGULAR_METRIC]: () => 'SINGULAR_METRIC',
    [BREAKDOWN]: () => 'BREAKDOWN',
    [SORTING_METRIC_EXPOSURE]: () => 'SORTING_METRIC_EXPOSURE',
    GRAPH_METRIC_EXPOSURE: (key) => `GRAPH_METRIC_EXPOSURE_${key}`,
    COMBO_METRIC_EXPOSURE: (key) => `COMBO_METRIC_EXPOSURE_${key}`,
    GRAPH_BREAKDOWN_EXPOSURE: (key) => `GRAPH_BREAKDOWN_EXPOSURE_${key}`,
    GOAL_METRICS: () => 'GOAL_METRICS',
    GOAL_TARGET_METRIC: (key) => `GOAL_TARGET_METRIC_${key}`,
    DATASTREAM_METRIC: () => 'DATASTREAM_METRIC',
    DATASTREAM_BREAKDOWN: () => 'DATASTREAM_BREAKDOWN',
};

export const MAX_GRAPH_METRIC_COUNT = 10;
export const MAX_CREATIVE_METRIC_COUNT = 10;
export const MAX_GOAL_METRIC_COUNT = 10;
export const MAX_QUICK_CONTROL_METRIC_COUNT = 20;
export const MAX_QUICK_CONTROL_BREAKDOWN_COUNT = 20;
